import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from "react-intl";
import EstablishmentShippingCostRow from "./EstablishmentShippingCostRow";
import EstablishmentShippingCostModal from "./EstablishmentShippingCostModal";
import ModalManager from "../sub/modals/ModalManager";

class EstablishmentShippingCosts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };
  }

  openShippingModal(index, successCallback) {
    this.setState({
      modal: (
        <EstablishmentShippingCostModal
          isOpen={true}
          index={index}
          establishmentId={this.props.establishmentId}
          shippingCosts={this.props.shippingCosts || []}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ModalManager
          showModal={true}
          title={this.props.intl.formatMessage({ id: "Confirm" })}
          content={this.props.intl.formatMessage({ id: "Remove.Row.Confirmation" })}
          modalType="confirmation"
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  render() {
    const shippingCosts = this.props.shippingCosts || [];

    var index = -1;
    let shippingCostNode = shippingCosts.map((shippingCost) => {
      return (
        <EstablishmentShippingCostRow
          index={++index}
          key={index}
          establishmentId={this.props.establishmentId}
          shippingCost={shippingCost}
          shippingCosts={shippingCosts}
          openConfModal={(title, content, successCallback) =>
            this.openConfModal(title, content, successCallback)
          }
          openShippingModal={(index, successCallback) =>
            this.openShippingModal(index, successCallback)
          }
        />
      );
    });

    return (
      <React.Fragment>
        {this.state.modal}
        {shippingCosts.length > 0 ? (
          <table className="table table-striped tablee4coll col-12">
            <thead>
              <tr>
                <th>
                  <span className="d-sm-none">
                    <FormattedHTMLMessage id="Min.Max" />
                  </span>
                  <span className="d-none d-sm-table-cell">
                    <FormattedMessage id="Minimum" />
                  </span>
                </th>
                <th className="d-none d-sm-table-cell">
                  <FormattedMessage id="Maximum" />
                </th>
                <th>
                  <FormattedMessage id="Shipping.Cost.Excl.Tax" />
                </th>
                <th>
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>
            <tbody>{shippingCostNode}</tbody>
          </table>
        ) : (
          <div className="alert alert-info">
            <FormattedMessage id="No.Shipping.Cost.Ranges.Configured" />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EstablishmentShippingCosts));
